import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { SearchOff as SearchOffIcon } from '@mui/icons-material';
import { appColors } from '../../Config/Theme';

interface HeadcountEmptyStateProps {
  onClearFilters: () => void;
}

const HeadcountEmptyState: React.FC<HeadcountEmptyStateProps> = ({ onClearFilters }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 6, px: 3 }}>
    <SearchOffIcon sx={{ fontSize: 48, color: appColors.text.placeholder, mb: 1.5 }} />
    <Typography variant="body1" sx={{ color: appColors.text.body, fontWeight: 600, mb: 0.5 }}>
      No people match the current search or filters.
    </Typography>
    <Typography variant="body2" sx={{ color: appColors.text.caption, mb: 2 }}>
      Try adjusting your search text, status filter, or alpha range.
    </Typography>
    <Button
      variant="outlined"
      onClick={onClearFilters}
      sx={{ textTransform: 'none', fontWeight: 600 }}
    >
      Clear filters
    </Button>
  </Box>
);

export default HeadcountEmptyState;
